export enum SortOrder {
  ASC = 1,
  DESC = -1,
}
